export default __webpack_public_path__ + "static/media/sage_logo.24f2f7f8.svg";